import React, { useEffect, useRef, useState } from "react";
import "./Dashboard.css";
import "../../cssfiles/homepage.css";
import MenuItem from "@mui/material/MenuItem";
import {
  createTheme,
  FormControl,
  Typography,
  ThemeProvider,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ThemeContext } from "../Homepage";
import { useContext } from "react";
import InputLabel from "@mui/material/InputLabel";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

export default function CustomSelectMenuItem({
  options,
  onChange,
  disabled,
  defaultValue,
  fontSize,
  width,
  name,
  disabledOptions = [],
}) {
  const { theme } = useContext(ThemeContext);
  const [selectedValue, setSelectedValue] = useState("");
  const [label, setLabel] = useState("");
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    onChange(selectedValue);
  }, [selectedValue]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setLabel("");
  };

  return (
    <FormControl disabled={disabled != null ? disabled : false}>
      <Select
        variant="standard"
        inputlabel="year"
        value={
          defaultValue && selectedValue === "" ? defaultValue : selectedValue
        }
        onChange={handleChange}
        style={{
          paddingBottom: "0px",
          paddingTop: "0px",
        }}
        name={name ? name : "yearSelect"}
        disableUnderline={disabled != null ? disabled : false}
        IconComponent={(props) => (
          <ExpandMoreOutlinedIcon style={{ width: "16px", height: "16px" }} />
        )}
        sx={{
          border: 0,
          width: width ? width : "224px",
          bgcolor: "none",
          color: "var(--GreyVariation_2)",
          fontSize: fontSize ? `${fontSize}px` : "18px",
          fontFamily: "Roboto",
          fontWeight: 400,
          textAlign: "left",
          borderRadius: 0,
          marginRight: "0px",
          "& .Mui-disabled": {
            borderBottom: "1px solid",
            borderBottomColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
            WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
          },
          "& .MuiSvgIcon-root": {
            fill:
              (disabled != null ? disabled : false) == true
                ? theme === "light"
                  ? "#C1C1C1"
                  : "#3C3C3C"
                : "var(--GreyVariation_2)",
          },
          ":before": { borderBottom: "1px solid var(--GreyVariation_2)" },
          ":after": { borderBottom: "2px solid #008CD7" },
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
              color: "red",
            },
          "& .MuiInputBase-input:focus": {
            color: "#008CD7",
            bgcolor: "none",
          },
          "& .MuiOutlinedInput-notchedOutline ": {
            width: "122.35px",
            border: 0,
            padding: 0,
          },
          "& .MuiInputLabel-root": { display: "none", legend: "none" },
          "& .MuiSelect-select": {
            paddingTop: "0px",
            paddingBottom: "0px",
            marginTop: "0px",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
          },
        }}
        InputLabelProps={{ shrink: false }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
              borderBottom: "2px solid #008CD7",
              borderRadius: 0,
              width: width ? width : "224px",
              boxShadow: "none",
              maxHeight: "250px",
              overflow: "auto",
              "::-webkit-scrollbar": {
                width: "4px",
                height: "4px",
              },
              "::-webkit-scrollbar-track": {
                borderRadius: "0px",
                background: "var(--Scrollbar_Track)",
              },
              "::-webkit-scrollbar-thumb": {
                background: "var(--Scrollbar_Thumb)",
                borderRadius: "5px",
              },
              "& .MuiMenuItem-root.Mui-selected": {
                fontWeight: 700,
                color: "#000000",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#005C8E",
                color: "#000000",
              },
              color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
            },
          },
        }}
      >
        {options.map((val) => {
          // Check if this meter should be disabled
          const isDisabled = disabledOptions.includes(val.id);

          return (
            <MenuItem
              sx={{
                fontSize: "16px",
                fontFamily: "Roboto",
                fontWeight: 400,
                opacity: isDisabled ? 0.5 : 1,
                pointerEvents: isDisabled ? "none" : "auto",
              }}
              key={val.id}
              value={val.id}
              disabled={isDisabled}
            >
              <Typography noWrap>
                {val.meterNumber ? val.meterNumber : val.name} -{" "}
                {val.meterType ? val.meterType : val.rate}
              </Typography>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
